import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import { pcmpAccessQueryOptions, type PcmpPermission } from '../api/pcmpAccess.api';

/**
 * The viewer's PCMP permissions, for showing actions a row carries no
 * capability for. The API still decides: a hidden button is a hint only.
 */
export function usePcmpPermissions() {
  const { data, isLoading } = useQuery(pcmpAccessQueryOptions());

  const can = useCallback(
    (...permissions: PcmpPermission[]) =>
      data !== undefined && permissions.every((p) => data.permissions.includes(p)),
    [data],
  );

  return { can, isLoading };
}
